import { API_DATE_FORMAT } from '@websky/core/src/utils';
import { addDays, parse } from 'date-fns';
export const convertOrderToHotelsSupplierData = (baseUrl, order) => {
    const firstSegmentGroup = order.flight.segmentGroups[0], lastSegmentGroup = order.flight.segmentGroups[order.flight.segmentGroups.length - 1], lastSegmentInFirstGroup = firstSegmentGroup.segments[firstSegmentGroup.segments.length - 1], lastSegment = order.flight.segments[order.flight.segments.length - 1], isRT = order.flight.segmentGroups.length === 2 &&
        firstSegmentGroup.segments[0].departure.airport.iata === lastSegment.segment.arrival.airport.iata;
    const parseDate = (date) => parse(date, API_DATE_FORMAT, new Date());
    const passengers = order.travellers.reduce((map, traveller) => {
        var _a, _b;
        map.set(traveller.type, {
            count: ((_b = (_a = map.get(traveller.type)) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0) + 1,
            passengerType: traveller.type,
            extendedPassengerType: traveller.supplierTravellerType
        });
        return map;
    }, new Map());
    const startDate = isRT
        ? parseDate(lastSegmentInFirstGroup.arrival.date)
        : parseDate(lastSegment.segment.arrival.date), endDate = isRT ? parseDate(lastSegmentGroup.segments[0].departure.date) : addDays(startDate, 1);
    return {
        baseUrl,
        destination: {
            iata: isRT ? lastSegmentInFirstGroup.arrival.airport.iata : lastSegment.segment.arrival.airport.iata,
            codes: []
        },
        startDate,
        endDate,
        passengersCount: order.travellers.length,
        passengers: [...passengers.values()]
    };
};
